/**
 * Converts markdown text to HTML
 * @param {string} markdown - Markdown text to convert
 * @returns {string} HTML string
 */
export const renderMarkdownToHtml = (markdown) => {
  let html = markdown;
  
  // Headers (må komme først)
  html = html.replace(/^### (.+)$/gm, '<h3 class="text-xl font-bold mt-4 mb-2 text-slate-800">$1</h3>');
  html = html.replace(/^## (.+)$/gm, '<h2 class="text-2xl font-bold mt-5 mb-3 text-slate-900">$1</h2>');
  html = html.replace(/^# (.+)$/gm, '<h1 class="text-3xl font-bold mt-6 mb-4 text-slate-900">$1</h1>');
  
  // Bold og italic
  html = html.replace(/\*\*(.+?)\*\*/g, '<strong class="font-bold text-slate-900">$1</strong>');
  html = html.replace(/\*(.+?)\*/g, '<em class="italic">$1</em>');
  
  // Lister
  html = html.replace(/^- (.+)$/gm, '<li class="ml-6 mb-2 list-disc">$1</li>');
  
  // Paragraphs (splitting på doble linjeskift)
  html = html.split('\n\n').map(para => {
    // Sjekk om det er heading eller liste
    if (para.trim().startsWith('<h') || para.trim().startsWith('<li')) {
      return para;
    }
    // Wrap i paragraph tag
    return `<p class="mb-4 text-slate-700">${para.replace(/\n/g, '<br />')}</p>`;
  }).join('');
  
  // Wrap lister i ul
  html = html.replace(/(<li[^>]*>.*?<\/li>)(<li[^>]*>.*?<\/li>)+/gs, (match) => {
    return `<ul class="mb-4 space-y-1">${match}</ul>`;
  });
  
  return html;
};
